import React from 'react'
import styled from 'styled-components'
import Checkbox, { CheckboxCustom } from 'components/Controls/Checkbox/StyledCheckbox'
import { css, rgba, grayscale, media, radiuses, colors } from 'styles'

const Element = ({ vipEnabled, ...props }) => (vipEnabled ? <div {...props} /> : <button type="submit" {...props} />)

const StyledMembershipCard = styled(Element)`
  position: relative;
  flex: 0 0 23rem;
  ${Checkbox} {
    position: relative;
    padding: 0 20px;
    border-right: ${({ selected }) =>
      css`
        ${selected ? '0.2' : '0.1'}rem solid ${colors.textMain};
      `};
  }
  ${CheckboxCustom} {
    position: relative;
    border-radius: 50%;
    svg {
      display: none;
    }
    ${({ selected }) =>
      selected &&
      css`
        background: ${colors.highlight};
      `}
  }
  text-align: center;
  border-radius: ${radiuses.large};
  line-height: 1.5;
  text-transform: uppercase;
  background-color: ${colors.mainBackground};
  cursor: pointer;
  color: ${colors.main};
  ${p => p.selected && `box-shadow: 0 0.8rem 1.6rem ${grayscale(p.theme.colors.main)}`};
  border: 0; /* for button */
  padding: 0; /* for button */
  outline: none; /* for button */
  ${({ vipEnabled, selected }) =>
    vipEnabled
      ? css`
          position: relative;
          overflow: visible;
          width: 100%;
          display: flex;
          border: ${selected ? '0.2' : '0.1'}rem solid ${colors.textMain};
          box-sizing: border-box;
          margin-bottom: 2rem;
          color: ${colors.mainInverted};
        `
      : css`
          width: 26rem;
          overflow: hidden;
        `}
  .membership-info {
    width: 100%;
  }

  .duration {
    box-sizing: border-box;
    padding: 1rem;
    background-color: ${p => rgba(colors.highlight, p.selected ? 1 : 0.7)};
    font: ${p => `${p.selected ? 600 : 300} 2.8rem ${p.theme.fonts.names.title}`};
    text-transform: uppercase;
    color: ${colors.mainInverted};
  }

  .membership-type {
    margin: 0 auto;
    padding: 1rem 0 0;
    font-size: 1.8rem;
    font-weight: 700;
    color: ${colors.highlight};
  }
  .currency,
  .period {
    font-weight: 300;
  }

  .savings {
    display: inline-flex;
    height: 2rem;
    margin-bottom: 2rem;
    border-radius: ${radiuses.large};
    font-size: 1.4rem;
    font-weight: 400;
    color: ${colors.mainInverted};
    ${({ vipEnabled }) =>
      vipEnabled &&
      css`
        position: absolute;
        top: -1rem;
        right: 1rem;
      `}

    &:not(:empty) {
      padding: 0.2rem 1rem;
      background: ${p => rgba(colors.main, p.selected ? 1 : 0.6)};
    }
  }

  .select-plan {
    padding: 0.6rem 0;
    border: 0.2rem solid ${colors.cta};
    border-radius: ${radiuses.large};
    background: ${colors.cta};
    color: ${colors.mainInverted};
    ${p => p.selected && 'font-weight: 800'};
    ${p =>
      !p.selected &&
      css`
        color: ${colors.cta};
        background: transparent;
      `};
  }
  .body {
    padding: 0 1rem 1rem;
    background: ${colors.mainInverted};
  }
  .savings--top {
    display: none;
  }

  ${media.mobile`
    width: 18rem;
    min-height: 22rem;

    .duration {
      font-size: 2.6rem;
    }

    .membership-type {
      font-size: 2rem;

      span {
        display: none;
      }
    }
  `}

  @media (max-width: 600px) {
    width: 90%;
    min-height: auto;
    max-width: 34rem;
    margin: 0 auto 2rem;
    display: flex;
    line-height: 1;

    .duration {
      writing-mode: vertical-lr;
      transform: rotate(180deg);
      text-orientation: mixed;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      white-space: nowrap;
      padding: 1rem;
      margin-right: 1rem;
      align-self: stretch;
      ${p =>
        p.vipEnabled &&
        css`
          writing-mode: lr;
          transform: none;
          width: 100%;
          border-radius: 0 ${radiuses.large} 0 0;
        `}
    }

    .body {
      align-self: center;
    }

    .savings {
      height: auto;
      margin: 0;
    }

    .savings--top {
      display: inline-block;
    }

    .savings--bottom {
      display: none;
    }

    .membership-type {
      text-align: right;
      margin-bottom: -2rem;
    }

    .body {
      width: 100%;
    }

    .select-plan {
      border: 0.1rem solid;
    }
  }
`

const MembershipPrice = styled.div`
  font-size: 1.8rem;

  .currency {
    display: inline-block;
    margin-right: 0.5rem;
    font-size: 4.6rem;
  }

  .value {
    display: inline-block;
    font-size: 4.8rem;
    font-weight: 700;
  }

  .coins {
    display: inline-block;
    vertical-align: 2.2rem;
    margin-right: -1em;
    font-weight: 700;
  }

  .period {
    display: inline-block;
    font-size: 1.2rem;
  }

  ${media.mobile`
    margin-bottom: 0;

    .currency {
      font-size: 4rem;
    }

    .value {
      font-size: 3.8rem;
    }

    .coins {
      vertical-align: 1.6rem;
    }
  `}

  @media (max-width: 600px) {
    margin-bottom: 1rem;
    // text-align: left;
    text-align: center;

    .currency {
      font-size: 5.8rem;
      font-weight: 600;
    }

    .value {
      font-weight: 600;
      font-size: 5.6rem;
    }

    .coins {
      font-weight: 600;
    }
  }
`

export default StyledMembershipCard
export { MembershipPrice }
